// Silent reading speed of a clinician on a summary, for the "min read" figure.
const READING_WORDS_PER_MINUTE = 200;

/** The "min read" figure of a text read in full: one minute at the least. */
export function readingMinutes(texts: string[]): number {
  const words = texts
    .join(" ")
    .split(/\s+/)
    .filter((word) => word !== "").length;
  return Math.max(1, Math.round(words / READING_WORDS_PER_MINUTE));
}

/**
 * The "min read" of an article outside its own page (a collection's list):
 * the summary and the digest the list received, or the abstract when there is
 * no digest. The article page counts what it shows, which a licence or the
 * access rules can cut down, so the two figures can differ on a gated paper.
 */
export function articleReadingMinutes(article: {
  tldr: string | null;
  background: string | null;
  objectives: string[];
  methodology: string | null;
  results: string[];
  limitations: string | null;
  conclusion: string[];
  abstractText: string | null;
}): number {
  const digest = [
    article.background === null ? "" : article.background,
    ...article.objectives,
    article.methodology === null ? "" : article.methodology,
    ...article.results,
    article.limitations === null ? "" : article.limitations,
    ...article.conclusion,
  ].filter((text) => text !== "");
  const body =
    digest.length > 0
      ? digest
      : article.abstractText === null
        ? []
        : [article.abstractText];
  return readingMinutes([article.tldr === null ? "" : article.tldr, ...body]);
}
